<div class="modal-header" *ngIf="modalTitle">
    <h4 class="modal-title" id="modal-basic-title">{{ modalTitle }}</h4>
    <button type="button" class="close text-white" aria-label="Close" (click)="closeAction()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" [innerHtml]="modalContent"></div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeAction()">{{ modalButton }}</button>
</div>